export default __webpack_public_path__ + "static/gabarito-categoria-JR-abb673a51f765590dec3f1166f5540c8.pdf";